import { BrowserRouter as Router } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import AppContent from './AppContent';

function App() {
	return (
		<Router>
			<SocketProvider>
				<AppContent />
			</SocketProvider>
		</Router>
	);
}

export default App;
